import { ApPayeeForm } from '@/features/ap_payees/components/AddNewPayeeDialog';
import { useTranslation } from '@/i18n';
import {
  FormInput,
  Label,
  Left,
  Right,
} from '@moneyforward/ap-frontend-components';
import { FC, memo, useMemo } from 'react';
import { Control } from 'react-hook-form';

export type TPayeeNameProps = {
  control: Control<ApPayeeForm>;
};
export const PayeeName: FC<TPayeeNameProps> = memo(({ control }) => {
  const { t } = useTranslation();

  const requiredRules = useMemo(
    () => ({
      required: t('required'),
    }),
    [t]
  );
  return (
    <>
      <Left>
        <Label required text={t('ap_payee_name')} htmlFor='name' />
      </Left>
      <Right>
        <FormInput<ApPayeeForm>
          control={control}
          name='name'
          inputId='name'
          rules={requiredRules}
        />
      </Right>
    </>
  );
});
PayeeName.displayName = 'PayeeName';
